import axios from "axios";
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { showNotify, closeToast } from "vant";
// import NProgress from 'nprogress'
import { getToken, removeToken } from "@/utils/index";
import { tansParams } from "@/utils/methods";
import { outDateSkip } from "@/utils/public";

const TIMEOUT = 20000;
class Request {
  interceptors(instance: AxiosInstance) {
    instance.interceptors.request.use((req: any) => {
      // NProgress.start()
      return req;
    });
    instance.interceptors.response.use(
      (res: AxiosResponse) => {
        // NProgress.done()
        if (res.status === 200) {
          if (res.data.code === 200) {
            return res.data;
          } else {
            if (res.data.code === 401) {
              closeToast();
              removeToken();
              outDateSkip();
              // if (window.location.hash != "/#" + (window.VITE_APP_LOGIN_PAGE || import.meta.env.VITE_APP_LOGIN_PAGE)) {
              //   window.location.href = window.location.origin + "/#" + (window.VITE_APP_LOGIN_PAGE || import.meta.env.VITE_APP_LOGIN_PAGE);
              // }
              // setTimeout(() => {
              //   window.location.reload();
              // }, 360);
              throw new Error("系统访问权限失败");
            } else if (res.data.code === 403) {
              closeToast();
              window.location.href = "/#/401";
              // closeToast()
              // removeToken()
              // console.log(window.location)
              // if (
              //   window.location.hash !=
              //   '/#' + (window.VITE_APP_LOGIN_PAGE || import.meta.env.VITE_APP_LOGIN_PAGE)
              // ) {
              //   window.location.href =
              //     window.location.href +
              //     '/#' +
              //     (window.VITE_APP_LOGIN_PAGE || import.meta.env.VITE_APP_LOGIN_PAGE)
              // }
            } else if (res.data.code === 404) {
              closeToast();
              window.location.href = "/#/404";
            } else {
              console.log(res);
              // 网络状态没问题，后台接口状态没问题，后台返回状态码不是200
              return res.data;
            }
            return;
          }
        } else {
          console.log("网络状态没问题，后台接口状态不对", res);
          showNotify({ type: "warning", message: res.statusText || "系统异常，请联系管理员" });
        }
      },
      (error) => {
        console.log(error);
        let { message } = error;
        if (message == "Network Error") {
          message = "网络连接异常";
        } else if (message.includes("timeout")) {
          message = "连接超时，请稍后尝试";
        } else if (message.includes("Request failed with status code")) {
          message = "未知异常，请联系管理员处理，错误码" + message;
        }
        console.log(error);
        showNotify({ type: "warning", message: message });
        return Promise.reject(error);
      }
    );
  }
  getConfig(config: AxiosRequestConfig): AxiosRequestConfig {
    const base: AxiosRequestConfig = {
      baseURL: window.VITE_APP_BASE_API || import.meta.env.VITE_APP_BASE_API,
      headers: {
        ...config.headers,
        "Content-Type": "application/json;charset=utf-8",
        Authorization: getToken()
      },
      timeout: config.timeout || TIMEOUT
    };
    // get请求映射params参数
    if ((config.method === "get" || config.method === "delete") && config.params) {
      let url = config.url + "?" + tansParams(config.params);

      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    if (config.url && config.url.includes("/login") && base.headers && base.headers["Authorization"]) {
      delete base.headers["Authorization"];
      return base;
    }
    // console.log(base);

    return base;
  }
  request(config: AxiosRequestConfig): Promise<AxiosResponse> {
    // console.log(config);

    const instance = axios.create(this.getConfig(config));
    this.interceptors(instance);
    return instance.request(config);
  }
}

const instance = new Request();

export default instance;
